<script>
import bem from '@/utils/bem';
import getPriceWithOrWithoutSale from '@/utils/getPriceWithOrWithoutSale';
import BeforeAfterPrice from '@/components/ux/beforAfterPrice/Before-after-price.vue';
import NewCheckButton from '@/components/ux/NewCheckButton/NewCheckButton.vue';
import BigCountInput from '@/components/ux/inputs/BigCountInput.vue';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import ChangeWizardCard from '@/components/modals/Change-wizard-card.vue';
import { mapActions } from 'vuex';

const b = bem('third-card-design');

export default {
  data() {
    return {
      price: 0,
      additionalDiscount: 0,
      isShowPersonalizePopUp: false,
      show: false,
    };
  },
  props: [
    'productName',
    'section',
    'index',
    'onLoadedData',
    'isStartPlay',
    'helpCenterList',
    'products',
    'cardsOrderUpdate',
  ],
  methods: {
    ...mapActions({
      deleteWizardCardAction: 'wizards/deleteWizardCard',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    togglePopUp(value) {
      this.isShowPersonalizePopUp = value;
    },
    modalToggle(value) {
      this.show = value;
    },
    onDelete() {
      this.deleteWizardCardAction({ id: this.section.id, type: this.productName });
    },
  },
  components: {
    ChangeWizardCard,
    BigCountInput,
    NewCheckButton,
    BeforeAfterPrice,
    LeftOutlined,
    RightOutlined,
  },
  mounted() {
    const {
      sales = [],
      quantity = 0,
      description,
      product,
    } = this.section;
    const feetCount = description.substring(0, description.indexOf(' '));
    const {
      price,
      additionalDiscount,
    } = getPriceWithOrWithoutSale({
      sales,
      quantity: quantity / feetCount,
      product,
    });
    this.price = Number(price);
    this.additionalDiscount = Number(additionalDiscount);
  },
};
</script>

<template>
  <div :class="b('')">
    <div :class="b('edit-button')">
      <a-button
        type="primary"
        size="small"
        @click="modalToggle(true)"
      >
        Edit
      </a-button>
    </div>
    <div :class="b('delete-button')">
      <a-popconfirm title="Sure to delete?" @confirm="onDelete">
        <a-button type="primary" size="small" html-type="button" danger>
          Delete
        </a-button>
      </a-popconfirm>
    </div>
    <ChangeWizardCard
      :section="section"
      title="Wizard card"
      :is-new-card="false"
      :products="products"
      :help-center-list="helpCenterList"
      v-model:show="show"
      :product-name="productName"
    />
    <div
        :class="b('wrap')"
        :style="{
          backgroundImage: `url(${
            isMobileDisplay &&  section.images.length > 1
            ? section.images[1] : section.images[0]})`
        }"
    >
      <button
        :class="b('personalize-btn-wrap', { desktop: true })"
        @click="togglePopUp(!isShowPersonalizePopUp)"
        v-if="section.product && section.product.name === 'personalize' && !isMobileDisplay"
      >
      <span :class="b('personalize-btn-text')">Personalize</span>
      </button>
      <div :class="b('bottom-block')">
        <div :class="b('bottom-block-title')">{{ section.title}}</div>
        <div
            :class="b('bottom-block-description')"
             v-if="section.description"
        >
          {{ section.description }}
        </div>
        <div
          :class="b('bottom-block-description')"
          v-if="section.innerDescription"
        >
          {{section.innerDescription}}
        </div>
        <div :class="b('bottom-quantity-block')">
          <div
              :class="b('middle-block-toggler')"
              v-if="section.product && section.product.isToggle"
          >
            <NewCheckButton
                :classNameToggleIcon="b('toggle-on-icon')"
                :checked="true"
                firstText="NO"
                textChecked="YES"
                :isSmall="true"
            />
          </div>
          <template v-else>
            <BigCountInput
                :className="b('quantity')"
                :inputClass="b('width-input')"
                :btnClassName="b('count-btn')"
                :bemCount='b'
                :withInput="true"
                :mainCounter="true"
                :minSize="true"
            />
          </template>
        </div>
        <div :class="b('bottom-block-price')">
          <BeforeAfterPrice
              :textBeforeClassName="b('before-text')"
              :textAfterClassName="b('after-text')"
              :priceClassName="b('price')"
              :priceAfterClassName="b('price-after')"
              :price="price"
              :additionalDiscount="additionalDiscount"
              :withoutPrice="Boolean(price === 0)"
              :textBefore="section.subTitle"
              textAfter=""
              :isRow="true"
          />
        </div>
        <button
            :class="b('personalize-btn-wrap', { mobile: true })"
            @click="togglePopUp(!isShowPersonalizePopUp)"
            v-if="section.product && section.product.name === 'personalize' && isMobileDisplay"
        >
          <span :class="b('personalize-btn-text')">Personalize</span>
        </button>
      </div>
    </div>
    <div :class="b('order-buttons')">
      <div :class="b('button', { right: true })" v-if="index > 0">
        <a-button
            type="primary"
            size="small"
            @click="cardsOrderUpdate(index, index - 1)"
        >
          <template #icon>
            <LeftOutlined />
          </template>
        </a-button>
      </div>
      <div
          :class="b('button', { left: true })"
          v-if="index !== lastIndex"
      >
        <a-button
            type="primary"
            size="small"
            @click="cardsOrderUpdate(index, index + 1)"
        >
          <template #icon>
            <RightOutlined />
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./thirdCardDesign.scss"></style>
